export const buttonVerticalMargin = '32px';
export const backButtonMt = 2;
export const titleMt = 2;
export const subtitleMarginTop = '4px';
export const subtitleMarginBottom = '32px';
